import { Disclosure } from '@headlessui/react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function SubPageTabs(props) {
  const { navigation, onTabClick } = props;

  return (
    <Disclosure as='header'>
      <div className='mx-auto sm:px-4 lg:divide-y lg:divide-gray-200 lg:px-8 lg:space-x-8 p-2'>
        <nav aria-label='Global'>
          {navigation.map((item) => (
            <div
              key={item.name}
              aria-current={item.current ? 'page' : undefined}
              onClick={(e) => {
                e.preventDefault();
                onTabClick(item.id);
              }}
              className={classNames(
                item.current
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900',
                'inline-flex items-center rounded-md px-3 py-2 text-sm font-medium cursor-pointer'
              )}
            >
              {item.name}
            </div>
          ))}
        </nav>
      </div>
    </Disclosure>
  );
}
